import React, { useState } from 'react';

function normalizeDate(value) {
  if (!value) return null;
  const d = String(value).trim().slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(d) ? d : null;
}

function formatForDisplay(dateStr) {
  const d = normalizeDate(dateStr);
  if (!d) return dateStr;
  const [y, m, day] = d.split('-');
  return `${day}.${m}.${y}`;
}

export default function ExcludedDates({ dates, onChange }) {
  const [draft, setDraft] = useState('');
  const list = Array.isArray(dates) ? dates : [];

  const add = () => {
    const normalized = normalizeDate(draft);
    if (!normalized) return;
    if (list.includes(normalized)) {
      setDraft('');
      return;
    }
    onChange([...list, normalized].sort());
    setDraft('');
  };

  const remove = (date) => {
    onChange(list.filter((d) => d !== date));
  };

  const handleKey = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      add();
    }
  };

  // Drop any dates that are in the past to keep the list tidy.
  const today = new Date().toISOString().slice(0, 10);
  const upcoming = list.filter((d) => d >= today);
  const past = list.filter((d) => d < today);

  return (
    <div className="excluded-dates">
      <div className="excluded-input-row">
        <input
          type="date"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={handleKey}
          min={today}
        />
        <button
          type="button"
          className="btn secondary"
          onClick={add}
          disabled={!normalizeDate(draft)}
        >
          Add
        </button>
      </div>

      {upcoming.length === 0 && past.length === 0 && (
        <p className="excluded-empty">No dates excluded. The bot will run on all scheduled days.</p>
      )}

      {upcoming.length > 0 && (
        <ul className="excluded-list">
          {upcoming.map((d) => (
            <li key={d} className="excluded-item">
              <span>{formatForDisplay(d)}</span>
              <button type="button" className="excluded-remove" onClick={() => remove(d)} title="Remove">
                ×
              </button>
            </li>
          ))}
        </ul>
      )}

      {past.length > 0 && (
        <details className="excluded-past">
          <summary>{past.length} past date{past.length === 1 ? '' : 's'}</summary>
          <ul className="excluded-list">
            {past.map((d) => (
              <li key={d} className="excluded-item stale">
                <span>{formatForDisplay(d)}</span>
                <button type="button" className="excluded-remove" onClick={() => remove(d)} title="Remove">
                  ×
                </button>
              </li>
            ))}
          </ul>
        </details>
      )}
    </div>
  );
}
